import React, { Fragment } from "react";
import _ from "lodash";
import "./ListItem.less";

// ------------------------------------------------------------------------------------------------
export interface ListItemProps {
    key?: string | number;
    primaryText?: string;
    secondaryText?: string;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    nestedItems?: React.ReactNode[];
    style?: React.CSSProperties;

    /**
     * Control list/Open Closed from mounting
     */
    initiallyOpen?: boolean;

    /**
     * sent evemt when a list is open
     */
    onNestedListToggle?: () => void;

    /**
     * when the system is clicked
     */
    onClick?: () => void;
}
// ------------------------------------------------------------------------------------------------
export interface ListItemState {
    listOpen: boolean;
}
// ------------------------------------------------------------------------------------------------
export default class ListItem extends React.Component<ListItemProps, ListItemState>{
    constructor(props: ListItemProps) {
        super(props);

        this.state = {
            listOpen: props.initiallyOpen ?? false
        }
    }
    // --------------------------------------------------------------------------------------------
    toggleList = () => {
        this.setState({ listOpen: !this.state.listOpen });
        if (this.props.onNestedListToggle != null)
            this.props.onNestedListToggle();
        if (this.props.onClick != null)
            this.props.onClick();
    }
    // --------------------------------------------------------------------------------------------
    render() {
        let validNestedItems = this.props.nestedItems != null && !_.isEmpty(this.props.nestedItems);

        return <Fragment>
            <div
                key={this.props.key}
                className="Yodiwo-ListItem"
                onClick={validNestedItems ? this.toggleList : this.props.onClick}
                style={{
                    ...this.props.style,
                    cursor: validNestedItems ? "pointer" : "default"
                }}
            >
                {
                    this.props.leftIcon != null ?
                        <div key="icon" id="icon">
                            {this.props.leftIcon}
                        </div> : null
                }

                <div id="body" key="body">
                    <div id="primaryText">{this.props.primaryText}</div>
                    {this.props.secondaryText != null ?
                        <div id="secondaryText">{this.props.secondaryText}</div>
                        : null}
                </div>

                {
                    this.props.rightIcon != null ?
                        <div key="icon" id="icon">
                            {this.props.rightIcon}
                        </div> : null
                }

                {
                    validNestedItems ?
                        ((this.state.listOpen) ?
                            <i className="fas fa-angle-up" id="arrow" key="arrow" /> :
                            <i className="fas fa-angle-down" id="arrow" key="arrow" />
                        ) : null
                }
            </div>
            {validNestedItems && this.state.listOpen ?
                <div key={this.props.key + "-nested"} className="Yodiwo-ListItem-NestedItems">{this.props.nestedItems}</div> :
                null}
        </Fragment>
    }
    // --------------------------------------------------------------------------------------------
}
// ------------------------------------------------------------------------------------------------